import { useQuery } from '@tanstack/react-query';
import type { MyOfferDto, OfferDto } from '@rw/shared';
import { api } from '../../lib/api';

export const offerKeys = { mine: ['me', 'offers'] as const, admin: ['admin', 'offers'] as const };

/** Codes this runner earned, newest first. */
export const useMyOffers = () => useQuery({ queryKey: offerKeys.mine, queryFn: () => api<MyOfferDto[]>('/me/offers') });

/** Game owner: every offer with its pool. */
export const useOffers = () => useQuery({ queryKey: offerKeys.admin, queryFn: () => api<OfferDto[]>('/admin/offers') });
